import { useDispatch, useSelector } from 'react-redux';
import { usePlanMutation } from 'redux/services/plannerService';
import { mapSlice } from 'redux/slices/mapSlice';
import { plannerSegmentsInformation } from 'redux/slices/plannerSegmentsSlice';
import { plannerInformation, plannerSlice } from 'redux/slices/plannerSlice';
import { plannerTimerInformation } from 'redux/slices/plannerTimerSlice';
import { userState } from 'redux/slices/userSlice';
import { IItemResultSearch } from 'types/interfaces';
import PlanUtils from 'utils/PlanUtils';
import RouteUtils from 'utils/RouteUtils';
import TimeUtils from 'utils/TimeUtils';
import { TYPES_MARKERS } from 'utils/constants';

export default function PlannerPresenter() {
  const dispatch = useDispatch();
  const [getPlan] = usePlanMutation();
  const plannerTimer: any = useSelector(plannerTimerInformation);
  const planner: any = useSelector(plannerInformation);
  const account: any = useSelector(userState);
  const segments: Array<IItemResultSearch> = useSelector(plannerSegmentsInformation);

  /**
   * @function onPlannerSegmentChange devuelve una planificación a partir de la
   * cumplimentación de todos los parámetros
   */
  async function onPlannerSegmentChange(onResult?: Function) {
    //dispatch(navigationSlice.actions.updateRouteDetailModal({ showModal:false, plan:null }))
    dispatch(plannerSlice.actions.updatePlanResult(undefined));
    dispatch(plannerSlice.actions.updateSelectedPlan(0));
    if (segments[0] && segments[1] && Object.keys(segments).length === 2) {
      //en caso de no tener paradas intermedias
      //dispatch(modalControlSlice.actions.updateShowExploreLoading(true));
      let ori = segments[0]?.position?.lat + ',' + segments[0]?.position?.lng;

      let dest =
        segments[segments.length - 1]?.position?.lat +
        ',' +
        segments[segments.length - 1]?.position?.lng;
      const resultPlan: any = await getPlan({
        origin: ori,
        destination: dest,
        time: plannerTimer.now
          ? TimeUtils.getTimePM_AM(TimeUtils.getTime(Date.now()))
          : plannerTimer.time,
        date: plannerTimer.date,
        operatorsFilters: planner.operatorsFilters,
        wheelchair: planner.accessibilityFilter,
        arriveBy: plannerTimer.arriveBy,
        deviceType: account.deviceTypeId,
        intermediateStops: '',
        intermediatePlacesId: '',
        toPlaceTypeId: PlanUtils.getTypeId(segments[segments.length - 1]?.type),
        toPlaceValue:
          segments[segments.length - 1]?.type === TYPES_MARKERS.DIRECTION
            ? segments[segments.length - 1]?.name
            : String(segments[segments.length - 1]?.id),
        fromPlaceTypeId: PlanUtils.getTypeId(segments[0]?.type),
        maxLegDuration: planner.maxWalkDistance ? planner.maxWalkDistance * 60 : null,
        fromPlaceValue: segments[0]?.type === TYPES_MARKERS.DIRECTION ? segments[0]?.name: String(segments[0]?.id),
      });

      if (resultPlan.data && resultPlan?.data?.plan) {
        let auxPlan = JSON.parse(JSON.stringify(resultPlan.data));
        auxPlan['plan']['itineraries'] = RouteUtils.resultsSorter(
          auxPlan.plan?.itineraries,
          planner?.order,
          // 'asc',
        );
        auxPlan['plan']['itineraries'] = auxPlan['plan']['itineraries'].slice(0, 6);
        dispatch(plannerSlice.actions.updatePlanResult(auxPlan));
        dispatch(plannerSlice.actions.updateSelectedPlan(0));
        onResult?.(auxPlan);
      }

      if (resultPlan?.error || resultPlan?.data[0]?.error) {
        if (resultPlan?.error?.status === 400) {
        } else {
        }
      }
      dispatch(
        mapSlice.actions.flyTo({
          coords: PlanUtils.getMidPoint(
            { longitude: segments[1].position?.lng, latitude: segments[1].position?.lat },
            { longitude: segments[0].position?.lng, latitude: segments[0].position?.lat },
          ),
          zoom: PlanUtils.getMidZoom(
            { longitude: segments[1].position?.lng, latitude: segments[1].position?.lat },
            { longitude: segments[0].position?.lng, latitude: segments[0].position?.lat },
          ),
        }),
      );
      //dispatch(modalControlSlice.actions.updateShowExploreLoading(false));
    } else {
      dispatch(plannerSlice.actions.updatePlanResult(null));
      //dispatch(modalControlSlice.actions.updateShowExploreLoading(false));
    }
  }

  return {
    onPlannerSegmentChange,
  };
}
